import { ReactElement, FC, useState, useEffect, memo } from 'react'

import { ASSETS } from '../../../constants'
import { useI18n } from '../../../hooks'
import { handleAuth } from '../../../services'
import { useAppSelector } from '../../../store'
import Image from '../../atoms/images/image'

const STUDENTS_NUMBER = 600
const FACULTY_NUMBER = 300

const StudentAndFaculty: FC = (): ReactElement => {
  const { isBootstrapLoaded } = useAppSelector((state) => state.appConfigReducer)
  const { user } = useAppSelector((state) => state.userReducer)

  const [showNumber, setShowNumber] = useState(0)
  const allNumber = STUDENTS_NUMBER + FACULTY_NUMBER
  const STUDENT_PERCENTAGE = (STUDENTS_NUMBER / allNumber) * 100

  useEffect(() => {
    if (showNumber < allNumber) {
      setTimeout(() => {
        setShowNumber(showNumber + 10)
      }, 8)
    }
  }, [showNumber, allNumber])
  const { t } = useI18n()
  return (
    <div className="about-student-and-faculty">
      <div className="about-student-and-faculty-info">
        <h1 className="heavy">{showNumber}K+</h1>
        <p>{t('About_studentsAndFacultyServed')}</p>
        {user ? null : (
          <button className="light" onClick={async () => isBootstrapLoaded && (await handleAuth())}>
            {t('About_joinOnTheHub')}
          </button>
        )}
      </div>
      <div className="about-student-and-faculty-animation">
        <Image
          className="about-student-and-faculty-img"
          src={`${ASSETS}/pages/about/about-student.svg`}
          alt="about page student and faculty image"
          size={{ width: 600, height: 'auto' }}
        />
        <div className="about-student-and-faculty-chart">
          <div className="about-student-and-faculty-chart-bar">
            <div style={{ flex: 1, height: '100%' }}>
              <div style={{ height: '100%', display: 'flex', width: `${(showNumber / allNumber) * 100}%` }}>
                <div className="about-student-and-faculty-student" style={{ width: `${STUDENT_PERCENTAGE}%` }}></div>
                <div className="about-student-and-faculty-faculty" style={{ width: `${100 - STUDENT_PERCENTAGE}%` }}></div>
              </div>
            </div>
            <p>{showNumber}K+</p>
          </div>
          <div className="about-student-and-faculty-legend">
            <div>
              <div className="about-student-chart-student-color"></div>
              <p>{t('Common_students')}</p>
            </div>
            <div>
              <div className="about-student-chart-faculty-color"></div>
              <p>{t('Common_faculty')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(StudentAndFaculty)
